import History from '../History';
import Tool, { type ToolArgs } from '../../tools/Tool';

class ToolUndo extends Tool {
  static toolName = 'Undo';
  static iconClass = 'fa-solid fa-rotate-left';
  static shortcut = 'Cmd+z';

  static action({ editor, element }: ToolArgs): void {
    History.undo(editor);
  }

  static isEnabled({ editor, element }: ToolArgs): boolean {
    return History.getForEditor(editor)?.canUndo;
  }
}

export default ToolUndo;
